<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="course.course_name + ' [Training Course] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-graduation-cap"></i> Training Courses
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses/view/${course.id}`">
                            {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Delete Training Course</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger mb-2">
                                <strong>Warning:</strong> You are about to permanently delete this Training Course. This cannot be undone. All of the following data below will also be deleted.
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteTrainingCourse()" :disabled="deleting">
                                <template v-if="deleting">
                                    Deleting <i class="fa fa-spin fa-spinner"></i>
                                </template>
                                <template v-else>
                                    Delete Employee Training Course
                                </template>
                            </button>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Files that will be deleted ({{ files.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <ul class="list-unstyled" v-if="files.length > 0">
                                <li v-for="file in files">
                                    <a :href="`/files/view/${file.file_id}`" target="_blank">{{ file.file_name }}</a></li>
                            </ul>
                            <div v-else>
                                -- No Files Attached to this Training Course --
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Employee Courses that will be deleted ({{ empCourses.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <ul class="list-unstyled" v-if="empCourses.length > 0">
                                <li v-for="empCourse in empCourses">
                                    {{ empCourse.completed_at | moment("MM/DD/YYYY") }} by {{ empCourse.FirstName }} {{ empCourse.LastName }}
                                </li>
                            </ul>
                            <div v-else>
                                -- No Employee Courses Attached to this Training Course --
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                course: {},
                files: [],
                empCourses: [],
            }
        },

        computed: {

        },

        methods: {

            getTrainingCourse() {
                //Get the data
                this.$http
                    .get('/training-courses/delete/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.files = response.data.files;
                        this.empCourses = response.data.empCourses;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteTrainingCourse(){
                //Setup
                this.deleting = true;

                //Get the data
                this.$http
                    .post('/training-courses/delete/' + this.id)
                    .then(response => {
                        //Alert the User
                        this.$toastr.success('Course Deleted');

                        //Redirect
                        this.$router.push('/training-courses');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.deleting = false;
                    });
            },

        },

        mounted() {
            //Get the Training Course
            this.getTrainingCourse();
        }
    }
</script>
